'use strict'

const SERVER_GOALS = new Set([
  'organiser_account_created',
  'organiser_event_draft_created',
  'organiser_register_success',
  'organiser_event_published',
  'organiser_registration_scheduled',
  'organiser_registration_opened',
])
const STEPS = new Set(['account', 'event', 'registration', 'confirm', 'success'])
const ACTION_GOALS = {
  expert: 'organiser_expert_mode_open',
  payment: 'organiser_payment_setup_click',
  share: 'organiser_event_link_shared',
  help: 'organiser_onboarding_help_click',
  error: 'organiser_onboarding_submit_error',
}

// Only funnel metadata belongs in analytics. Never forward form values or errors.
function safeParams(params = {}) {
  const safe = {onboarding_version: 2}
  if (STEPS.has(params.step)) safe.step = params.step
  if (['free', 'paid'].includes(params.participation)) safe.participation = params.participation
  if (['publish', 'open', 'schedule'].includes(params.launch)) safe.launch = params.launch
  if (['native', 'clipboard'].includes(params.method)) safe.method = params.method
  if (['validation', 'authentication', 'access', 'network', 'server'].includes(params.error_type)) safe.error_type = params.error_type
  return safe
}

function createOnboardingAnalytics(send) {
  const seen = new Set()
  function emit(goal, params, callback) {
    try { return send(goal, safeParams(params), callback) !== false }
    catch (_) { return false }
  }
  function once(key, goal, params) {
    if (seen.has(key)) return
    if (emit(goal, params)) seen.add(key)
  }

  return {
    pageView(step) {
      once('page', 'organiser_register_page_view', {step})
    },
    stepView(step) {
      if (!STEPS.has(step)) return
      once(`step:${step}`, 'organiser_onboarding_step_view', {step})
      if (step === 'registration') once('2_step', '2_step', {step})
    },
    response(response) {
      if (!response || response.success !== true || !Array.isArray(response.goals)) return
      for (const goal of response.goals) {
        if (!SERVER_GOALS.has(goal)) continue
        once(`${response.state && response.state.event_id}:${goal}`, goal, response.goal_params)
      }
    },
    action(action, params) {
      if (ACTION_GOALS[action]) emit(ACTION_GOALS[action], params)
    },
    beforeNavigate(action, params) {
      return new Promise(resolve => {
        const timer = setTimeout(resolve, 350)
        const done = () => { clearTimeout(timer); resolve() }
        if (!ACTION_GOALS[action] || !emit(ACTION_GOALS[action], params, done)) done()
      })
    },
  }
}

module.exports = {createOnboardingAnalytics}
